import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import { ShouldUpdate } from '../../../modules/ShouldUpdate.js';
import '../../katapult-maps-desktop/address-tool-options.js';
import { SetItemData } from '../katapult-custom-function-editor-step.js';

export class AddressToolEditorStep extends LitElement {
  static get properties() {
    return {
      toolItemData: { type: Object },
      otherAttributes: { type: Object },
      commitToItemData: { type: Function }
    };
  }

  static styles = css``;

  constructor() {
    super();

    this.setItemData = SetItemData.bind(this);

    // comes from katapult-custom-function-editor-step.js
    this.toolItemData = {};
    this.otherAttributes = {};
  }

  willUpdate(changedProperties) {}

  shouldUpdate(changedProperties) {
    return ShouldUpdate(this, changedProperties);
  }

  render() {
    return html`
      <address-tool-options
        .config=${this.toolItemData?.function_config}
        .attributeModels=${this.otherAttributes}
        @config-changed=${(event) => this.setItemData('function_config', event.detail.value ?? null)}
      ></address-tool-options>
    `;
  }
}
customElements.define('address-tool-editor-step', AddressToolEditorStep);
